import { IStopArea } from '../../../../models/stop-area.model';
import { TariffZoneApiModel } from './tariff-zone.api-model';

export class StopAreaApiModel {
  public static mapToBusinessModel(apiModel: StopAreaApiModel): IStopArea {
    return {
      gid: apiModel.gid ?? '', // This should never happen but APR allows the stop area gid to be null
      name: apiModel.name ?? '',
      latitude: apiModel.latitude,
      longitude: apiModel.longitude,
      tariffZone1: apiModel.tariffZone1 ? TariffZoneApiModel.mapToBusinessModel(apiModel.tariffZone1) : undefined,
      tariffZone2: apiModel.tariffZone2 ? TariffZoneApiModel.mapToBusinessModel(apiModel.tariffZone2) : undefined,
      stopPoints: [],
    };
  }

  public gid?: string;
  public name?: string;
  public latitude?: number;
  public longitude?: number;
  public tariffZone1?: TariffZoneApiModel;
  public tariffZone2?: TariffZoneApiModel;
}
